import styled from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const MainBannerItemType2 = styled.div`
  width: inherit;
  height: inherit;
  position: relative;

  .btn {
    min-height: ${mixin.pxToVw('400')};
    background: #f6f6f6
      url('//static.wconcept.co.kr/display/images/onerror_img_product.png')
      no-repeat center / cover;
  }

  .img {
    padding-bottom: 106.6667%;
  }

  .thumbnail {
    &:after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.03);
      transform: translateZ(0);
    }
  }

  .textBox {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 20px 20px 35px 20px;
    text-align: left;
    transform: translateZ(0);
    z-index: 3;

    &:after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 150px;
      background: linear-gradient(
        180deg,
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 0.5) 100%
      );
    }
  }

  .text {
    position: relative;
    width: 100%;
    color: #fff;
    transition-property: transform, opacity;
    transition-duration: 0.2s;
    transition-delay: 0.28s;
    transition-timing-function: ease-out;
    z-index: 1;

    &.title1,
    &.title2 {
      font-weight: 600;
      line-height: 120%;
      font-size: 22px;
    }

    &.subTitle {
      margin-top: 8px;
      line-height: 130%;
      font-size: 13px;
    }
  }

  @media ${({ theme }) => theme.media.smMax} {
    .btn {
      &:after {
        height: ${mixin.pxToVw('150')};
      }
    }

    .textBox {
      padding: ${mixin.pxToVw('20 20 35 20')};
    }

    .text {
      &.title1,
      &.title2 {
        font-size: ${mixin.pxToVw('22')};
      }

      &.subTitle {
        margin-top: ${mixin.pxToVw('8')};
        font-size: ${mixin.pxToVw('13')};
      }
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    .btn {
      min-height: auto;
    }

    .img {
      padding-bottom: 106.98%;
    }

    .thumbnail img {
      object-position: center bottom;
    }

    .img img {
      transform: translateZ(0);
      backface-visibility: hidden;
    }

    .textBox {
      padding: 40px 36px;

      &:after {
        height: 198px;
      }
    }

    .text {
      &.title1,
      &.title2 {
        line-height: 130%;
        font-size: 32px;
      }

      &.subTitle {
        line-height: 135%;
        margin-top: 12px;
        font-size: 16px;
        padding-right: 0;
      }
    }
  }
`;
